/* eslint-disable max-len */
import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { ViewBase } from '../../../../components/common/ViewBase'
import { ErrorBoundary } from '../../../../components/common/ErrorBoundary'
import { Button, ButtonVariant } from '../../../../components/common/Button'
import { reverseUrl } from '../../../../navigation/reverseUrl'
import { useCurrentSociety } from '../../../../hooks/useCurrentSociety'
import { Icon, IconChoices } from '../../../../components/common/Icon'
import { theme } from '../../../../theme/theme'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../navigation/reverseDocumentTitle'
import { KUNDO_SUPPORT_LINK } from '../../../../constants/Links'
import { LinkButton } from '../../../../components/common/LinkButton'
import { i18nSocietyType } from '../../../../i18n'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'

export const RegisterGuidanceView = (): React.ReactNode => {
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:register-guidance', {
      '{{ societyName }}': society?.name,
    })
  )
  const navigate = useNavigate()
  const { translate } = useAppTranslation()
  const id = society?._id

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('registerGuidanceView.title', {
          context: i18nSocietyType(society?.societyTypeDisplayName),
        })}
        subtitle={translate('registerGuidanceView.subTitle', {
          context: i18nSocietyType(society?.societyTypeDisplayName),
        })}
      >
        <div className="flex flex-col gap-3">
          <p style={theme.textVariants.base}>
            {translate('registerGuidanceView.description', {
              context: i18nSocietyType(society?.societyTypeDisplayName),
            })}
          </p>

          <span style={theme.textVariants.base}>
            {translate('registerGuidanceView.howToDo')}:
          </span>
          <ol
            className="list-inside list-decimal"
            style={theme.textVariants.base}
          >
            <li>
              {translate('registerGuidanceView.goto')}{' '}
              <Link
                to={reverseUrl('management:register', { id })}
                className="text-brandGreen underline"
              >
                {translate('registerGuidanceView.register')}
              </Link>{' '}
              {translate('registerGuidanceView.link', {
                context: i18nSocietyType(society?.societyTypeDisplayName),
              })}
            </li>
            <li>
              {translate('registerGuidanceView.link', {
                context: i18nSocietyType(society?.societyTypeDisplayName),
              })}
            </li>
          </ol>

          <p style={theme.textVariants.base}>
            {translate('registerGuidanceView.tips', {
              context: i18nSocietyType(society?.societyTypeDisplayName),
            })}
          </p>
        </div>
        <div className="my-8 rounded-md bg-brandLightGreen p-5">
          <div className="flex items-center">
            <Icon
              icon={IconChoices.INFORMATION}
              color={theme.colors.brandGreen}
            />
            <p style={theme.textVariants.lead} className="ml-2">
              {translate('registerGuidanceView.tips', {
                context: i18nSocietyType(society?.societyTypeDisplayName),
              })}
            </p>
          </div>
          <p style={theme.textVariants.base} className="mt-2">
            {translate('registerGuidanceView.ifMany', {
              context: i18nSocietyType(society?.societyTypeDisplayName),
            })}
          </p>
        </div>
        <div className="flex gap-3">
          <Button
            label="Till register"
            variant={ButtonVariant.PRIMARY}
            onClick={() => navigate(reverseUrl('management:register', { id }))}
          />
          <LinkButton
            label="Kontakta support"
            url={KUNDO_SUPPORT_LINK}
            urlIsExternal
            variant={ButtonVariant.DEFAULT}
          />
        </div>
      </ViewBase>
    </ErrorBoundary>
  )
}
